module.exports = __webpack_public_path__ + "static/media/Racefiets-kopen-advies.adf6dff4.mp4";